import { useWidgetData } from '../useWidgetData'

import { StatisticWidget } from '../../../types/widget/widget'

export const useHoursPlayedWidget = () =>
  useWidgetData<StatisticWidget>('hours-played')
